import React, { useState, useEffect } from 'react';
import { getCmsCollection } from '../lib/cms';
import { imageUrl } from '../lib/images';
import GalleryModal from './GalleryModal';

export default function CmsGallery({ referenceSlug, title, subtitle }) {
  const [gallery, setGallery] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeModalIndex, setActiveModalIndex] = useState(null);

  useEffect(() => {
    let isMounted = true;
    async function loadGallery() {
      try {
        const res = await getCmsCollection('gallerier', { reference_slug: referenceSlug });
        if (isMounted) {
          if (res.items && res.items.length > 0) {
            setGallery(res.items[0]);
          }
          setLoading(false);
        }
      } catch (err) {
        console.error('Kunne ikke hente galleri:', err);
        if (isMounted) setLoading(false);
      }
    }

    loadGallery();
    return () => {
      isMounted = false;
    };
  }, [referenceSlug]);

  if (loading) {
    return (
      <div className="py-8 flex justify-center text-xs text-[#8A8172]">
        <i className="fa-solid fa-spinner fa-spin mr-2" /> Henter billeder...
      </div>
    );
  }

  if (!gallery || !gallery.billeder || gallery.billeder.length === 0) {
    return null;
  }

  const images = (gallery.billeder || []).filter(
    (u) => !String(u).includes('relancering-nyhedsbrev')
  );

  return (
    <div className="my-10">
      {(title || gallery.titel) && (
        <div className="mb-6 text-center max-w-2xl mx-auto">
          <h3 className="text-xl sm:text-2xl font-bold text-[#39463A]">
            {title || gallery.titel}
          </h3>
          {(subtitle || gallery.beskrivelse) && (
            <p className="text-xs sm:text-sm text-[#39463A]/80 mt-1.5">
              {subtitle || gallery.beskrivelse}
            </p>
          )}
        </div>
      )}

      {/* Grid of gallery images */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {images.map((imgUrl, idx) => (
          <button
            key={idx}
            type="button"
            onClick={() => setActiveModalIndex(idx)}
            className="group relative aspect-4/3 rounded-xl overflow-hidden bg-[#F4EFE5] border border-[#DED3C0] focus:outline-hidden focus:ring-2 focus:ring-[#71806A]"
          >
            <img
              src={imageUrl(imgUrl, 'width=600,quality=85,format=auto')}
              alt={`Galleri billede ${idx + 1}`}
              className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-[#39463A]/0 group-hover:bg-[#39463A]/30 transition-colors flex items-center justify-center">
              <span className="w-10 h-10 rounded-full bg-white/90 text-[#39463A] flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity shadow-lg">
                <i className="fa-solid fa-magnifying-glass-plus text-sm" aria-hidden="true" />
              </span>
            </div>
          </button>
        ))}
      </div>

      {/* Full screen modal */}
      <GalleryModal
        images={images}
        initialIndex={activeModalIndex || 0}
        isOpen={activeModalIndex !== null}
        onClose={() => setActiveModalIndex(null)}
      />
    </div>
  );
}
